import React, { useState } from "react";
import { IconButton } from "@mui/material";
import IncidentNotesDialog from "../IncidentNotesDialogue/IncidentNotesDialogue";
import NoteAltIcon from "@mui/icons-material/NoteAlt";

interface IncidentNotesButtonProps {
  incidentId: string;
}

const IncidentNotesButton: React.FC<IncidentNotesButtonProps> = ({
  incidentId,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <IconButton
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          setOpen(true);
        }}
      >
        <NoteAltIcon />
      </IconButton>
      <IncidentNotesDialog
        open={open}
        onClose={() => setOpen(false)}
        incidentId={incidentId}
      />
    </>
  );
};

export default IncidentNotesButton;
